import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="m5.025 6.961.064-.07 2.19-5.349c.138-.33.44-.54.77-.54h5.637c.146 0 .293.04.421.12l3.95 2.44c.211.13.358.34.403.6l.074.35L19.55 9.45l2.135 2.89c.092.13.156.29.174.45l1.128 9.168a.95.95 0 0 1-.202.72.82.82 0 0 1-.632.31H1.845a.84.84 0 0 1-.632-.3.93.93 0 0 1-.211-.71L2.129 10.37c.019-.21.11-.4.248-.55l.669-.73m6.35 4.59c.587-.49 1.375-.77 2.2-.77s1.613.28 2.2.77c.55.46.825 1.12.916 1.919l.764 7.387h-7.71l.714-7.357c.184-.89.394-1.5.917-1.95"
      clipRule="evenodd"
    />
  </>
);

const CollCaves = Icon('coll-caves', svgContents);

export default CollCaves;
